export default __webpack_public_path__ + "static/media/imgNature2.b8a96828.jpg";